import {navigate} from "@reach/router";

export const redirectToDashboard= () => navigate('/dashboard')
export const redirectToProfilePhotos = () => navigate('/new')
export const redirectToLogin = () => navigate('/')
